import { css, StyleSheet } from 'aphrodite';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ZIndex } from '../constants';
import { Alert, AlertVM } from '@lean-body/components/molecules/alert';
import { MediaBreakPointUp } from '@lean-body/components/styles/variables';
export const AlertContainer = observer(class AlertContainer extends React.Component {
    render() {
        return React.createElement("div", { className: this.containerClass }, this.alerts);
    }
    get alerts() {
        return this.props.vm.alertVMs.map((vm) => {
            return React.createElement(Alert, { key: vm.uuid, vm: vm, className: css(this.styles.alert) });
        });
    }
    get containerClass() {
        return [this.props.className || '', css(this.styles.container)].join(' ');
    }
    get styles() {
        return StyleSheet.create({
            container: {
                position: 'fixed',
                top: 64,
                right: '1rem',
                zIndex: ZIndex.Alert,
                width: 'calc(100% - 2rem)',
                [MediaBreakPointUp.MD]: {
                    top: 8,
                    width: 'auto',
                    minWidth: '40%',
                },
            },
            alert: {
                marginBottom: 10,
            },
        });
    }
});
export class AlertContainerVM {
    constructor() {
        Object.defineProperty(this, "alertVMs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        makeObservable(this, {
            alertVMs: observable,
        });
    }
    showMessage(message, group = '', isError = false) {
        this.removeAlertGroup(group);
        message.split('\n').forEach((m) => {
            const vm = new AlertVM(m, group, isError);
            this.addAlert(vm);
            vm.lifeEnd.then(() => {
                this.removeAlert(vm);
            });
        });
    }
    showError(error, fallbackMessage, group) {
        if ((error === null || error === void 0 ? void 0 : error.displayMessage) !== null && (error === null || error === void 0 ? void 0 : error.displayMessage) !== undefined) {
            return this.showMessage(error.displayMessage, group, true);
        }
        this.showMessage(fallbackMessage, group, true);
    }
    addAlert(vm) {
        this.alertVMs.push(vm);
    }
    removeAlert(vm) {
        this.alertVMs = this.alertVMs.filter((a) => {
            return a.uuid !== vm.uuid;
        });
    }
    removeAlertGroup(group) {
        if (!group || group === '') {
            return;
        }
        this.alertVMs = this.alertVMs.filter((a) => {
            return a.group !== group;
        });
    }
}
